import { call, put, takeLeading, takeLatest } from "redux-saga/effects";
import { go, push } from "connected-react-router";
import { Routes } from "../../const/routes";
import { ConsolidateAPI } from "services/consolidate";
import { alertError } from "redux/reducers/master";

import {
  getAccounts,
  getAccountsSuccess,
  getAccountsFailure,
  redirectPWMRegister,
  saveDataMemory,
  redirectSuitability,
  redirectDisclaimer1,
  redirectDisclaimer2,
  registerPWM,
  registerPWMSuccess,
  registerPWMFailure,
} from "redux/reducers/pwm";
import { filterFields } from "utils/common-util";
import { AcceptType } from "const";
import { openModal } from "redux/reducers/central-modal";
import moment from "moment-timezone";
import { redirect, setRedirectUrl } from "redux/reducers/redirect";
import { checkRiskProfile, checkUserTypeSaga } from "./customer";

function* getAccountCustomer() {
  try {
    const response = yield call(ConsolidateAPI.getAccounts);
    yield put(getAccountsSuccess(response.data.accountList));
  } catch (error) {
    yield put(getAccountsFailure(error));
  }
}

function* saveDataMemorySaga(action) {
  try {
    let data = action.payload;
    yield put(saveDataMemory(data));
  } catch (error) {
    yield put(alertError(error));
  }
}

function* redirectPWMRegisterSaga(action) {
  try {
    yield call(checkRiskProfile);
    yield put(saveDataMemory({ disclaimers: action.payload }));
    yield put(push(Routes.UltraHigh.PrivateWealthManagement.RegisterForm));
  } catch (error) {
    yield put(alertError(error));
  }
}

function* redirectSuiteTestSaga(action) {
  try {
    yield put(saveDataMemory({ ...action.payload }));
    yield put(
      setRedirectUrl({ id: "suitability", url: Routes.UltraHigh.PrivateWealthManagement.RegisterForm, replace: true })
    );
    yield put(push(Routes.Register.Suitability));
  } catch (error) {
    yield put(alertError(error));
  }
}

function* redirectPWMDisclaimer1Saga(action) {
  try {
    let data = action.payload;
    yield put(saveDataMemory({ ...data }));
    const pageRoute = Routes.UltraHigh.PrivateWealthManagement.RegisterDisclaimer1;
    yield put(push(pageRoute));
  } catch (error) {
    yield put(alertError(error));
  }
}

function* redirectPWMDisclaimer2Saga(action) {
  try {
    let data = action.payload;
    yield put(saveDataMemory({ ...data }));
    const pageRoute = Routes.UltraHigh.PrivateWealthManagement.RegisterDisclaimer2;
    yield put(push(pageRoute));
  } catch (error) {
    yield put(alertError(error));
  }
}

function* registerPWMSaga(action) {
  try {
    let data = action.payload;
    const uniqueDisclaimer = data.disclaimers.filter((val, id, array) => array.indexOf(val) === id);
    data = { ...data, disclaimers: uniqueDisclaimer.join(",") };
    let listInvestmentsInfo = [];

    listInvestmentsInfo.push({
      category: "01",
      topic: "01",
      opt: data.investmentObjectives,
      optOther: data.investmentObjectives === "99" ? data.investmentObjectivesOther : "",
    });
    listInvestmentsInfo.push({
      category: "01",
      topic: "02",
      opt: data.workCountry === "TH" ? data.workCountry : "99",
      optOther: data.workCountry !== "TH" ? data.workCountry : "",
    });
    data.income.map((value, index) =>
      listInvestmentsInfo.push({
        category: "01",
        topic: "03",
        opt: value,
        optOther: value === "OTH" ? data.incomeSourceOthDesc : "",
      })
    );
    listInvestmentsInfo.push({
      category: "01",
      topic: "04",
      opt: data.totleIncome,
      optOther: "",
    });
    data = {
      ...data,
      address: data.mailingAddress,
      province: data.mailingProvince,
      district: data.mailingDistrict,
      subDistrict: data.mailingSubDistrict,
      postcode: data.mailingZipCode,
      workAddress: data.workMailingAddress,
      workProvince: data.workMailingProvince,
      workDistrict: data.workMailingDistrict,
      workSubDistrict: data.workMailingSubDistrict,
      workPostcode: data.workMailingZipCode,
      rcvAddress: data.rcvMailingAddress,
      rcvProvince: data.rcvMailingProvince,
      rcvDistrict: data.rcvMailingDistrict,
      rcvSubDistrict: data.rcvMailingSubDistrict,
      rcvPostcode: data.rcvMailingZipCode,
      investmentsInfo: listInvestmentsInfo,
      birthDate: moment(data.birthDay).toDate().getTime(),
      incomeCountrySource: data.workCountry,
    };

    data = filterFields(data, confirmPWMFields);

    const response = yield call(ConsolidateAPI.registerPWM, data);
    const paymentInfo = response.data.result;
    yield put(registerPWMSuccess(paymentInfo));

    // query register status and message
    yield call(checkUserTypeSaga);

    // show success dialog
    const payloadModal = {
      code: AcceptType.PwmRegisterInfo,
      state: { messageCode: "private.wealth.management.success", showIcon: true },
      actions: {
        acceptAction: [go(-3), redirect("pwm_register")], // -3 come from 3 step register's history page stack
        onClose: redirect("pwm_register"),
      },
    };
    yield put(openModal(payloadModal));
  } catch (error) {
    yield put(registerPWMFailure(error));
  }
}

const saga = [
  // takeLeading(getSuitabilityData.type, getResultSuitabilityDataPWM),
  takeLeading(getAccounts.type, getAccountCustomer),
  takeLeading(redirectPWMRegister.type, redirectPWMRegisterSaga),
  takeLeading(redirectSuitability.type, redirectSuiteTestSaga),
  takeLeading(saveDataMemory.type, saveDataMemorySaga),
  takeLeading(redirectDisclaimer1.type, redirectPWMDisclaimer1Saga),
  takeLeading(redirectDisclaimer2.type, redirectPWMDisclaimer2Saga),
  takeLatest(registerPWM.type, registerPWMSaga),
];

export default saga;

const confirmPWMFields = [
  "disclaimers",
  "accountType",
  "address",
  "province",
  "district",
  "subDistrict",
  "postcode",
  "phoneNo",
  "mobileNo",
  "faxNo",
  "email",
  "receiveMethod",
  "receiveMethodType",

  "dividendAccountType",
  "dividendAccountRef",
  // 'taxDeductionType',

  "birthDate",
  "nationality",
  "maritalStatus",
  "spouse",
  "workAddress",
  "workProvince",
  "workDistrict",
  "workSubDistrict",
  "workPostcode",
  "workPhoneNo",
  "workFaxNo",
  "rcvAddress",
  "rcvProvince",
  "rcvDistrict",
  "rcvSubDistrict",
  "rcvPostcode",
  "occupation",
  "occupationOther",
  "workType",
  "workTypeOther",
  "workName",
  "workPosition",
  "workCountry",
  "investmentsInfo",
  "countryCodeOfBirth",
  "cityCodeOfBirth",
  "cityOfBirth",
];
